
import { defineComponent, onMounted, ref } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { keieiJohoRepositories } from '@/repositories/keiei-joho/keieiJohoRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { KeieiJokyoUiItem } from '@/views/keiei-joho/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import { HospitalClinicKbnType, hospitalClinicKbnType } from '@/repositories/keiei-joho/data'
import KeieiJokyoSettingItem from '@/views/keiei-joho/keiei-info/KeieiJokyoSettingItem.vue'

const repository = keieiJohoRepositories.keieiJokyoSetting

export default defineComponent({
  components: {
    KeieiJokyoSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const hospitalItems = ref<KeieiJokyoUiItem[]>([])
    const clinicItems = ref<KeieiJokyoUiItem[]>([])

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        await refreshUiData()
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        let params = hospitalItems.value.map(v => v.item)
        params = params.concat(clinicItems.value.map(v => v.item))
        await repository.save(params)
        await refreshUiData()
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const onChangeInput = (kbn: HospitalClinicKbnType, item: KeieiJokyoUiItem) => {
      const items = getUiItems(kbn)
      UiItemsLogic.updateUiItem(items, item)
    }

    const getUiItems = (kbn: HospitalClinicKbnType): KeieiJokyoUiItem[] => {
      switch (kbn) {
        case hospitalClinicKbnType.Hospital:
          return hospitalItems.value
        case hospitalClinicKbnType.Clinic:
          return clinicItems.value
        default:
          throw Error('unknown type')
      }
    }

    const refreshUiData = async () => {
      const data = await repository.list()
      hospitalItems.value = data.items.filter(v => v.hospitalClinicKbn === hospitalClinicKbnType.Hospital).map(value => ({ item: value, isValid: true }))
      clinicItems.value = data.items.filter(v => v.hospitalClinicKbn === hospitalClinicKbnType.Clinic).map(value => ({ item: value, isValid: true }))
    }

    return {
      loading,
      isSucceedRequest,
      requestError,
      hospitalClinicKbnType,
      hospitalItems,
      clinicItems,
      onClickRegister,
      onDismissAlert,
      onChangeInput
    }
  }
})
